@if (visible) {
  <div class="selection-powens">
    <div class="selection-powens__overlay" (click)="fermer()"></div>
    <section
      class="selection-powens__panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="selection-powens-titre"
      >
      <header class="selection-powens__header">
        <div>
          <p class="selection-powens__eyebrow">Import bancaire Powens</p>
          <h3 id="selection-powens-titre">Choisir les comptes à importer</h3>
        </div>
        <button
          type="button"
          class="selection-powens__close"
          aria-label="Fermer"
          [disabled]="chargement"
          (click)="fermer()"
          >
          &times;
        </button>
      </header>
      <div class="selection-powens__body">
        @if (chargement && comptes.length === 0) {
          <div class="selection-powens__loading">
            <i class="ph ph-circle-notch" aria-hidden="true"></i>
            Chargement des comptes Powens…
          </div>
        }
        @if (erreur) {
          <p class="selection-powens__error">{{ erreur }}</p>
        }
        @if (comptes.length > 0) {
          <p class="selection-powens__intro">
            Choisissez le compte courant principal, puis cochez chaque carte
            différée ou compte associé dont les opérations doivent être ajoutées.
          </p>
          <fieldset class="selection-powens__section">
            <legend>1. Compte principal</legend>
            @for (compte of comptes; track trackByCompteId($index, compte)) {
              <label
                class="compte-powens"
                [class.compte-powens--selected]="comptePrincipalSelectionne === compte.id"
                >
                <input
                  type="radio"
                  name="compte-principal-powens"
                  [checked]="comptePrincipalSelectionne === compte.id"
                  [disabled]="chargement"
                  (change)="selectionnerComptePrincipal(compte.id)"
                  />
                <span class="compte-powens__content">
                  <span class="compte-powens__title">
                    {{ compte.nom }}
                    <span class="compte-powens__badge">{{ typeLisible(compte.type) }}</span>
                  </span>
                  <span class="compte-powens__details">
                    <span>ID {{ compte.id }}</span>
                    @if (compte.numeroMasque) {
                      <span>{{ compte.numeroMasque }}</span>
                    }
                    @if (formatterMontant(compte.solde); as solde) {
                      <span>Solde {{ solde }}</span>
                    }
                    @if (formatterMontant(compte.aVenir); as aVenir) {
                      <span>À venir {{ aVenir }}</span>
                    }
                  </span>
                </span>
              </label>
            }
          </fieldset>
          <fieldset class="selection-powens__section">
            <legend>2. Cartes différées et comptes associés</legend>
            <p class="selection-powens__hint">
              Tous les autres comptes restent proposés, même si la banque n’a pas
              correctement identifié leur type. Cochez uniquement ceux à importer.
            </p>
            @for (compte of comptesAssociesDisponibles; track trackByCompteId($index, compte)) {
              <label
                class="compte-powens"
                [class.compte-powens--selected]="estCompteAssocieSelectionne(compte.id)"
                >
                <input
                  type="checkbox"
                  [checked]="estCompteAssocieSelectionne(compte.id)"
                  [disabled]="chargement"
                  (change)="basculerCompteAssocie(compte.id, $any($event.target).checked)"
                  />
                <span class="compte-powens__content">
                  <span class="compte-powens__title">
                    {{ compte.nom }}
                    <span class="compte-powens__badge">{{ typeLisible(compte.type) }}</span>
                    @if (estProbablementUneCarte(compte)) {
                      <span class="compte-powens__badge compte-powens__badge--card">
                        Carte détectée
                      </span>
                    }
                  </span>
                  <span class="compte-powens__details">
                    <span>ID {{ compte.id }}</span>
                    @if (compte.numeroMasque) {
                      <span>{{ compte.numeroMasque }}</span>
                    }
                    @if (compte.compteParentId !== null) {
                      <span>Rattaché au compte {{ compte.compteParentId }}</span>
                    }
                    @if (formatterMontant(compte.solde); as solde) {
                      <span>Solde {{ solde }}</span>
                    }
                    @if (formatterMontant(compte.aVenir); as aVenir) {
                      <span>À venir {{ aVenir }}</span>
                    }
                  </span>
                </span>
              </label>
            }
            @if (comptesAssociesDisponibles.length === 0) {
              <p class="selection-powens__empty">
                Aucun autre compte ou carte n’est actuellement exposé par Powens.
              </p>
            }
          </fieldset>
        }
        @if (!chargement && comptes.length === 0 && !erreur) {
          <div class="selection-powens__empty">
            Aucun compte n’est disponible. Ajoutez ou activez vos comptes dans Powens.
          </div>
        }
      </div>
      <footer class="selection-powens__actions">
        <button
          type="button"
          class="btn-powens-manage"
          [disabled]="chargement"
          (click)="gererDansPowens.emit()"
          >
          Gérer les autorisations Powens
        </button>
        <span class="selection-powens__actions-spacer"></span>
        <button type="button" class="btn-powens-cancel" [disabled]="chargement" (click)="fermer()">
          Annuler
        </button>
        <button
          type="button"
          class="btn-powens-save"
          [disabled]="chargement || comptePrincipalSelectionne === null"
          (click)="valider()"
          >
          <i
            class="ph"
            [ngClass]="chargement ? 'ph-circle-notch' : 'ph-check'"
            aria-hidden="true"
          ></i>
          {{ chargement ? 'Enregistrement…' : 'Enregistrer et importer' }}
        </button>
      </footer>
    </section>
  </div>
}
